require('./angulartics');
module.exports = 'angulartics';



// WEBPACK FOOTER //
// ./node_modules/angulartics/src/index.js